export const PORTFOLIO_TOGGLE_CONFIG = Object.freeze({
    PORTFOLIOS: {
      innovation: {
        id: 7,
        slug: 'innovation',
        name: 'Innovation',
        icon: '/images/icons/innovation-icon.svg',
        activeColor: 'bg-orange-400',
        translationKey: 'innovation',
      },
      'water-saving': {
        id: 8,
        slug: 'water-saving',
        name: 'Water Saving',
        icon: '/images/icons/water-saving.svg',
        activeColor: 'bg-teal-400',
        translationKey: 'water saving',
      },
    },
  
    DEFAULT_PORTFOLIO: {
      id: 2,
      slug: 'chemicals',
      name: 'Chemicals',
    },
  
    SOLUTIONS_LAYER_ID: 'key-solutions',
  });